import React from 'react';
import { motion } from 'framer-motion';
import { Code2, Globe } from 'lucide-react';
import { cn } from '../../../../utils/cn';
import { ProjectCategory } from '../../types';

interface ProjectImageProps {
  image: string;
  title: string;
  category: ProjectCategory;
  featured?: boolean;
  fit?: 'natural';
}

export const ProjectImage: React.FC<ProjectImageProps> = ({ 
  image, 
  title, 
  category,
  featured,
  fit
}) => {
  return (
    <div className={cn("relative overflow-hidden bg-[#1a1a1a]", fit !== 'natural' && "aspect-[16/10]")}>
      <img
        src={image}
        alt={title}
        className={fit === 'natural'
          ? "block h-auto w-full"
          : "absolute inset-0 h-full w-full object-cover object-top"}
        loading="lazy"
      />
      
      {/* Category badge */}
      <div className="absolute top-4 left-4 z-20 flex items-center space-x-2">
        <motion.div
          whileHover={{ scale: 1.05 }}
          className={cn(
            "inline-flex items-center px-3 py-1.5",
            "bg-black/80",
            "border border-white/20"
          )}
        >
          {category === 'Mobile App' ? (
            <Code2 className="w-4 h-4 mr-2 text-white" />
          ) : (
            <Globe className="w-4 h-4 mr-2 text-white" />
          )}
          <span className="text-sm font-medium text-white">
            {category}
          </span>
        </motion.div>

        {featured && (
          <motion.div
            whileHover={{ scale: 1.05 }}
            className={cn(
              "px-3 py-1.5 rounded-lg",
              "bg-primary-400/90 backdrop-blur-sm",
              "border border-primary-300/20",
              "shadow-lg shadow-primary-900/20"
            )}
          >
            <span className="text-sm font-medium text-white">
              Featured
            </span>
          </motion.div>
        )}
      </div>
    </div>
  );
};